import S3Image from 'Components/S3Image'
import { type isdServiceProvider } from 'core/types'
import { LocationDisplay } from 'Components/Cards/LocationCard/LocationDisplay'
import { LargeCard } from 'Components/Cards/Large'

export function ServiceProviderCardDisplay (props: { serviceProvider: isdServiceProvider }): JSX.Element {
  return <LargeCard header={props.serviceProvider.name} content={<>
    {(props.serviceProvider.s3Key ?? '') !== '' && (
      <S3Image imageKey={props.serviceProvider.s3Key ?? 'none'} alt='Service Provider Image' />
    )}
    {props.serviceProvider.location !== null && props.serviceProvider.location !== undefined && (
      <LocationDisplay location={props.serviceProvider.location} />
    )}
  </>
  }
  />
}
